<script setup lang="ts">
import type { Icon } from '@nordhealth/components'
import { useCurrentDir } from '@/composables/i18next.js'

/**
 * A helper component for rendering an arrow icon with a logical direction.
 * This is useful for arrows that should be flipped in RTL.
 * The logical names are mapped to their physical nordicon counterparts.
 */
const props = defineProps<{
  name:
    | 'arrow-start-small'
    | 'arrow-end-small'
    | 'arrow-start'
    | 'arrow-end'
    | 'arrow-start-long'
    | 'arrow-end-long'
  size?: Icon['size']
  label?: Icon['label']
}>()

const dir = useCurrentDir()
const physicalName = computed(() =>
  props.name
    .replace('start', dir.value === 'ltr' ? 'left' : 'right')
    .replace('end', dir.value === 'ltr' ? 'right' : 'left'),
)
</script>

<template>
  <nord-icon :name="physicalName" :size :label></nord-icon>
</template>
